import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/frontier-exposure-analysis/')({
  beforeLoad: ({ context, preload }) => {
    const { validatePermissions, featureFlags } = context;
    const isAllowed = !!featureFlags[FeatureFlags.FrontierExposure];
    validatePermissions({ isAllowed, preload });
  },
});
